import { space } from '@repo/theme/primitives';

export const SPOTLIGHT_WIDTH = space[160]; // 640px
